import { render, staticRenderFns } from "./MeasurementList.vue?vue&type=template&id=72be0817&scoped=true&"
import script from "./MeasurementList.vue?vue&type=script&lang=js&"
export * from "./MeasurementList.vue?vue&type=script&lang=js&"
import style0 from "./MeasurementList.vue?vue&type=style&index=0&id=72be0817&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72be0817",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PhpstormProjects\\warehouse\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72be0817')) {
      api.createRecord('72be0817', component.options)
    } else {
      api.reload('72be0817', component.options)
    }
    module.hot.accept("./MeasurementList.vue?vue&type=template&id=72be0817&scoped=true&", function () {
      api.rerender('72be0817', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/typo3conf/ext/ig_warehouse/Resources/Public/Src/JavaScript/components/dialog/MeasurementList.vue"
export default component.exports